module.exports = __webpack_public_path__ + "img/email.947c809f.svg";